module.exports = __webpack_public_path__ + "static/scale-model-of-sibley-volcanic-regional-preserve-in-oakland-california-6447eb84953feccd4762ef66befdf77d.png";